import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormEditorProps } from '.';
import { ToolbarGroups } from '../../../components/Editor/config/registry';

export const generate = (
  props?: Partial<IFormFieldSchema<IFormEditorProps>>
): IFormFieldSchema<IFormEditorProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Editor',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormEditor,
    'x-validator': [],
    'x-component-props': {
      disabled: false,
      visible: true,
      height: undefined,
      placeholder: '',
      menubar: false,
      statusbar: true,
      branding: false,
      toolbarGroups: [
        ToolbarGroups.History,
        ToolbarGroups.Formatting,
        ToolbarGroups.Lists,
        ToolbarGroups.Table,
      ],
    },
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
